import { render } from "./DetailedProjectDocuments.vue?vue&type=template&id=3d5b57a6&scoped=true"
import script from "./DetailedProjectDocuments.vue?vue&type=script&lang=js"
export * from "./DetailedProjectDocuments.vue?vue&type=script&lang=js"

import "./DetailedProjectDocuments.vue?vue&type=style&index=0&id=3d5b57a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5b57a6"]])

export default __exports__